function getYMD(date: Date) {
    // Get YYYY-MM-DD format from date
    return [
        date.getFullYear(),
        `0${date.getMonth() + 1}`.slice(-2),
        `0${date.getDate()}`.slice(-2),
    ].join('-');
}

export default getYMD;
